import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";

export interface MacroColumnProps {
  label: string;
  grams: number;
  pct: number;
  barColor: string;
}

export const MacroColumn = ({ label, grams, pct, barColor }: MacroColumnProps) => {
  const width = "w-17.5";
  return (
    <div className={cn("flex flex-1 flex-col items-center gap-3", width)}>
      <span className={cn(textVariants.title3)}>{label}</span>
      <span className={cn(textVariants.footnote, "opacity-70 text-center")}>
        {grams}g ({pct}%)
      </span>
      <div className="relative h-1.5 w-17.5 overflow-hidden rounded-full bg-[#F2F2F2]">
        <div
          className={cn(
            "absolute top-0 left-0 h-full rounded-full transition-all duration-500",
            barColor,
          )}
          style={{ width: `${Math.min(pct, 100)}%` }}
        />
      </div>
    </div>
  );
};
